import { render, staticRenderFns } from "./ProgettoRiabilitativoIndividualeEditComponent.vue?vue&type=template&id=2e4ec6bd&scoped=true"
import script from "./ProgettoRiabilitativoIndividualeEditComponent.vue?vue&type=script&lang=js"
export * from "./ProgettoRiabilitativoIndividualeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4ec6bd",
  null
  
)

export default component.exports